import type {ConnectElementConfig} from '../ConnectElementList';

export const EditPayoutDestinationConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "EditPayoutDestination" */
      '../../../components/Account/PayoutInformation/PayoutSchedule/EditPayoutDestinationEntryPoint'
    ),
  enabledKey: 'payouts',
  releaseState: 'internal',
  sentryTeam: 'accounts_ui',
  teamOwner: 'connected-account-experiences-eng',
  description: "Payout component's entry point to edit payout destination",
  friendlyName: 'Payouts entry point: edit payout destination',
  htmlEvents: ['payoutdestinationeditingcomplete'],
  customHtmlElementMethods: {
    // Internal only for closing the authenticated webview in the mobile SDK
    setOnPayoutDestinationEditingComplete: {
      type: 'EventListenerMethod',
      event: 'payoutdestinationeditingcomplete',
      isInternal: true,
      description:
        'Sets the event listener for when the user finishes editing the payout destination',
    },
  },
};
